<template>
  <div class="select-content filter-field">
    <!-- <el-dropdown class="filter-model-dropdown" trigger="click" v-if="showSelect">
      <div class="el-dropdown-link">{{showMenu}}</div>
      <el-dropdown-menu class="filter-dropdown-menu" slot="dropdown">
        <el-dropdown-item v-for="item in accuracyOptions" :key="item.value" @click.native="handleCommand(item)">
          {{item.label}} {{item.describe}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <el-select v-model="value" v-bind="$attrs" :clearable='clearable' :filterable="true" :placeholder="$attrs.placeholder || '请选择'" @change="selectChange"
      v-if="!custom">
      <el-option v-for="(item, index) in options" :key="index" :label="item[props.label]" :value="item[props.value]">
      </el-option>
    </el-select>
    <slot v-else name="select"></slot>
  </div>
</template>
<script>
export default {
  name: 'yblSelect',
  model: {
    prop: 'item',
    event: 'change'
  },
  props: {
    showSelect: { // 是否可以选择
      type: Boolean,
      default: () => false
    },
    clearable: { // 是否清空
      type: Boolean,
      default: () => true
    },
    item: {
      type: String | Number | Array,
      default: () => ''
    },
    props: {
      type: Object,
      default: function () {
        return { label: 'label', value: 'value' }
      }
    },
    options: { // 字典
      type: Array,
      default: () => []
    },
    custom: { // 是否自定义选择框
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      value: '',
      select: 1,
      showMenu: '=',
      accuracyOptions: [{
        value: 1,
        label: '=',
        describe: '等于'
      }
        // {
        //   value: 2,
        //   label: '!=',
        //   describe: '不等于'
        // }, {
        //   value: 3,
        //   label: '=',
        //   describe: '等于任意一个'
        // }, {
        //   value: 4,
        //   label: '!=',
        //   describe: '不等于任意一个'
        // }
      ]
    }
  },
  created () {
    this.value = this.item
  },
  mounted () {
  },
  methods: {
    handleCommand (item) {
      this.showMenu = item.label
    },
    monitor (e) {
      console.log(e)
    },
    selectChange (value) {
      this.$emit('change', value)
    }
  },
  watch: {
    'item': function (newVal, oldVal) {
      this.value = newVal
    }
  }
}
</script>
<style lang="less" scoped>
@import "../assets/less/color.less";
.select-content {
  display: inline-block;
  &.filter-field {
    min-width: 190px;
    // display: flex;
    align-items: center;
    .filter-model-dropdown {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      cursor: pointer;
      background-color: #fff;
      border: 1px solid #dde0e6;
      border-radius: 2px 0px 0px 2px;
      border-right: none;
      flex: none;
      .el-dropdown-link {
        padding: 6px;
        color: #a4a5a7;
        line-height: 1;
        width: 14px;
        height: 14px;
        text-align: center;
      }
    }
    /deep/.el-input {
      .el-input__inner {
        border-radius: 2px;
      }
    }
    /deep/.filter-model-dropdown + .el-select {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    /deep/.filter-model-dropdown + .company-container {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  &_prepend {
    width: 34px;
    margin-left: -17px;
    // height: 30px;
    // background-color: #fff;
    /deep/.el-input__suffix {
      display: none;
    }
    /deep/ .el-input {
      width: 34px;
      min-width: 34px;
      .el-input__inner {
        width: 34px;
        padding: 0 10px 0 12px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
  .custom-date__box {
    height: 30px;
    line-height: 30px;
    border-radius: 0;
    align-items: self-end;
    /deep/.el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/select.vue